import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { CmsLoginComponent } from './login.component';

const routes: Routes = [
    {
        path: 'login',
        component: CmsLoginComponent
    }
];

@NgModule({
    imports: [
        RouterModule.forChild(routes)
    ],
    exports: [
        RouterModule
    ]
})
export class LoginRoutingModule {}
